import React, { Component } from 'react';
import { connect } from 'react-redux';
import MySelect from '../components/MySelect';
import { selectOptions } from '../actions/options';

class SelectHouseType extends Component {
  inputProps = {
    name: 'houseType'
  };
  // options=[
  //     {
  //         type:null,
  //         value:OptionTypes.HOUSE_NONE,
  //         text:'なし（軒並み）',
  //     },
  //     {
  //         type:null,
  //         value:OptionTypes.HOUSE_COMPLEX,
  //         text:'集合',
  //     },
  //     {
  //         type:null,
  //         value:OptionTypes.HOUSE_SINGLE,
  //         text:'戸建',
  //     },
  // ]
  // defaultValue = OptionTypes.HOUSE_NONE

  handleChangeSelect(value) {
    this.props.selectOptions({ houseTypeId: value });
  }

  // 軒並み（n）限定ルールを適用
  getOptions = () => {
    const { options, rootAreaId, rulesNormalHouseTypeByArea, areas } = this.props;

    if (!rulesNormalHouseTypeByArea) {
      return [];
    }
    if (rulesNormalHouseTypeByArea.areaIds.indexOf(rootAreaId) !== -1) {
      return rulesNormalHouseTypeByArea.options;
    }

		const areaIds = rulesNormalHouseTypeByArea.areaIds
		const hitAreas = areas.list.filter( a =>
			( areaIds.indexOf(a.id) > -1 )
			|| ( areaIds.indexOf(a.parent_id) > -1 )
			|| ( areaIds.indexOf(a.grandparent_id) > -1 )
		)

		if(hitAreas.length > 0){
			return rulesNormalHouseTypeByArea.options;
		}


    return options;
  };

  render() {
    const {
      defaultValue,
      // options
			errors
    } = this.props;
		let error = null
		if( errors !== undefined && 'houseType' in errors ){
				error = errors.houseType
		}
    return (
      <MySelect
        handleChange={this.handleChangeSelect.bind(this)}
        inputProps={this.inputProps}
        options={this.getOptions()}
        defaultValue={defaultValue}
				error={error}
      />
    );
  }
}

const mapStateToProps = state => ({
  defaultValue: state.options.selected.houseTypeId,
  options: state.options.houseType,
  rulesNormalHouseTypeByArea: state.options.rules.NormalHouseTypeByArea,
  rootAreaId: state.areas.rootAreaId,
	errors: state.options.errors,
	areas: state.areas,
});

const mapDispatchToProps = dispatch => ({
  selectOptions: selected => dispatch(selectOptions(selected))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SelectHouseType);



// WEBPACK FOOTER //
// ./src/components/SelectHouseType.js